module.exports = __webpack_public_path__ + "img/tiktok-go.d0e1f7d4.png";